export default {
  widgets: {
    pilotOffers:"Oferty pilota",
    auctions: "Giełda",
    departmentList: "Moje oddziały",
    warehouseList: "Moje magazyny",
    documentList: "Moje dokumenty",
    leasingList: "Leasingi",
    driverList: "Kierowcy",
    workerList: "Pracownicy",
    groupList: "Moje grupy",
    monitoryArchive: "Archiwum awizacji",
    companyData: "Firma",
    outsideWarehouse: "Magazyny zewnętrzne",
    auctionParticipants: "Członkowie zleceń",
    auctionArchive: "Archiwum zleceń",
    walletTimeWindows: "Okna czasowe",
    walletSub: "Abonament",
    invoicesList: "Faktury",
    factoring: "Faktoring",
    transports: "Transporty",
    surcharges: "Dopłaty",
    currentAuctionsAvailable:"Zlecenia"
  },
};
